import { useCalendarGridStore } from '../../store/calendar-grid.store';
import { EventRenderer } from './event-renderer';

interface Props {
  columnId: string;
}

export const ColumnEvents = ({ columnId }: Props) => {
  const columnInfo = useCalendarGridStore((s) => s.columnsById[columnId]);

  if (!columnInfo?.eventIds.length) return null;

  return columnInfo.eventIds.map((eventId) => <EventRenderer key={eventId} eventId={eventId} />);
};
